import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import { cn } from '@/lib/utils'
import { ChevronDownIcon } from 'lucide-react'
import React, { useRef } from 'react'
import { ArrowAccordion } from './ui/Accordion'

interface IProps {
    title: React.ReactNode
    defaultOpen?: boolean
    className?: string
    children: React.ReactNode
    scrollToView?: boolean
}

/**
 * Seção de formulário anunciada por um {@link HorizontalDivider} cujo rótulo é o
 * gatilho de expandir/retrair. Não renderiza `Grid` — para
 * não acoplar a componente ao layout de quem a usa.
 */
export default function CollapsibleSection({
    title,
    children,
    className,
    defaultOpen = false,
    scrollToView = false,
}: IProps) {
    const ref = useRef<HTMLDivElement>(null)

    return (
        <ArrowAccordion.Root
            type="single"
            collapsible
            variant="ghost"
            defaultValue={defaultOpen ? 'item-1' : undefined}
            onValueChange={() => {
                if (scrollToView)
                    setTimeout(() => {
                        ref.current?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        })
                    }, 200)
            }}
        >
            <ArrowAccordion.Item value="item-1" ref={ref}>
                <ArrowAccordion.Trigger
                    className={cn(
                        'data-[state=open]:[&_svg]:rotate-180',
                        className,
                    )}
                >
                    <HorizontalDivider className="mb-4">
                        <span
                            className={cn(
                                'inline-flex items-center hover:bg-accent',
                                'transition-colors duration-200 p-2 rounded-md',
                            )}
                        >
                            <span>{title}</span>
                            <ChevronDownIcon
                                className={cn(
                                    'ml-2 size-5 block!',
                                    'transition-all duration-200',
                                )}
                            />
                        </span>
                    </HorizontalDivider>
                </ArrowAccordion.Trigger>
                <ArrowAccordion.Content>{children}</ArrowAccordion.Content>
            </ArrowAccordion.Item>
        </ArrowAccordion.Root>
    )
}
